import * as React from "react";

function SvgUserManagement(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#UserManagement_svg__clip0)" fill="#fff">
        <path d="M21 17.37c-.197-3.758-3.542-5.313-3.542-5.313-.781-.368-2.182-1.082-3.132-1.57C15.339 9.445 16 7.738 16 5.81v-.045c.101-1.18.018-2.317.018-2.317C15.786.05 12.388-.003 12.032 0H12h-.027c-.323-.004-3.758.03-3.991 3.447 0 0-.084 1.14.018 2.322v.04c0 1.929.66 3.636 1.674 4.679-.95.488-2.35 1.2-3.132 1.57 0 0-3.345 1.554-3.542 5.311 0 0-.058.625 1.116.862 0 0 3.594.828 7.884.828 4.291 0 7.885-.828 7.885-.828 1.173-.237 1.114-.862 1.114-.862z" />
        <path d="M24 7h-7v.5h6.478v13H.522v-13H7V7H0v14h11.5v2h-4a.5.5 0 000 1h9a.5.5 0 000-1h-4v-2H24V7z" />
      </g>
      <defs>
        <clipPath id="UserManagement_svg__clip0">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgUserManagement;
